import { importNewList } from "./import-new-list";
import { newList } from "./new-list";
import { report } from "./report";
import { infos } from "./infos";
import { promoter } from "./promoter";

export const guestList = {
	title: "Lista de Invitados",
	importList: "Importar Lista",
	createList: "Crear Lista",
	searchList: "Buscar lista",
	list_one: "lista",
	list_other: "listas",
	guestsNotImported: "Invitados no importados",
	addGuestError: {
		relationReachesLimit: "Lista ya alcanzó el límite de invitados",
		userAlreadyExists: "Invitado ya registrado en la lista",
		userWithoutDocument: "Invitado sin documento",
	},
	columns: {
		name: "Nombre de la Lista",
		description: "Descripción",
		userCount: "Invitados",
		guest: "Invitado",
		expiresAt: "Expiración",
		status: "Estado",
		active: "ACTIVO",
		inactive: "DESACTIVADO",
	},
	deleteModal: {
		title: "Eliminar Lista",
		message: "¿Está seguro que desea eliminar esta(s) lista(s)?",
		confirm: "Eliminar Lista",
	},
	importNewList,
	newList,
	report,
	promoter,
	emptyList: {
		defaultMessage: "Parece que aún no ha creado una lista",
		defaultText: "Las listas aparecerán aquí cuando tenga una lista registrada.",
	},
	infos,
	menuDrop: {
		disable: "Desactivar lista",
		enable: "Activar lista",
		download: "Descargar",
		print: "Imprimir",
		edit: "Editar",
		delete: "Eliminar",
	},
	sheet: {
		filename: "lista_{{name}}",
		title: "Lista: {{name}}",
		columns: {
			name: "Nombre",
			cpf: "RFC",
			phone: "Teléfono",
			promoter: "Promotor",
		},
		example: "lista (ejemplo)",
		error: "Hoja de cálculo inválida",
	},
	list: {
		goBack: "Volver a listas",
		import: {
			label: "Importar hoja de cálculo de invitados",
			description:
				"Para importar una lista de invitados solo debe subir una hoja de cálculo",
		},
		sheet: {
			title: "Lista de invitados",
			error:
				"Hoja de cálculo inválida, descárguela nuevamente y haga los cambios necesarios. En caso de líneas vacías en rojo, elimínelas e intente nuevamente.",
		},
		success: "Hoja de cálculo importada con éxito",
		warning:
			"Antes de importar la hoja de cálculo, asegúrese de que todas las líneas en blanco sean eliminadas",
		delete: {
			permanentlyList: "Eliminar lista permanentemente",
			permanentlyLists: "Eliminar listas permanentemente",
			list: "Eliminar lista",
			lists: "Eliminar listas",
			selectedList:
				"La lista seleccionada será eliminada permanentemente y su información (invitados, check-in, ticket promedio, entrada, consumo, promotores) será eliminada de los informes. Esta acción no podrá ser deshecha. ¿Desea continuar de todos modos?",
			selectedLists:
				"Las listas seleccionadas serán eliminadas permanentemente y su información (invitados, check-in, ticket promedio, entrada, consumo, promotores) será eliminada de los informes. Esta acción no podrá ser deshecha. ¿Desea continuar de todos modos?",
		},
		print: {
			noEntrance: "Sin entrada asociada a esta lista.",
			date: "Fecha de emisión",
			entrance: "Entrada asociada",
			discount: "Tipo de descuento",
			description: "Descripción",
			expiresAt: "Expira a las",
		},
	},
	utils: {
		expiresAt: "Expira en",
		hasExpired: "Expiró hace",
		expires: "Expira",
		invalidName: "Nombre inválido",
		insertLastName: "Ingrese un apellido",
	},
};
